
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { HasAccess } from "../../../redux/accessUtils";
import { Grid, GridItem, Text, Menu, MenuButton, MenuItem, MenuList, useDisclosure, Flex, Tooltip, Box } from '@chakra-ui/react';
import { DeleteIcon, ViewIcon, EditIcon, } from "@chakra-ui/icons";
import { CiMenuKebab } from "react-icons/ci";
import { getApi } from "services/api";
import CommonCheckTable from '../../../components/checkTable/checktable';
import Add from "./Add";
import Edit from "./Edit";
import ImportModal from './components/ImportModal';
import CommonDeleteModel from 'components/commonDeleteModel';
import { deleteManyApi } from 'services/api';
import { fetchPropertyCustomFiled } from '../../../redux/propertyCustomFiledSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPropertyData } from '../../../redux/propertySlice'
import { toast } from 'react-toastify';

const Index = () => {
    const title = "Properties";
    const size = "lg";
    const user = JSON.parse(localStorage.getItem("user"));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [permission] = HasAccess(['Properties']);
    const [isLoding, setIsLoding] = useState(false);
    // const [data, setData] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [columns, setColumns] = useState([]);
    const [dataColumn, setDataColumn] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [action, setAction] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [propertyData, setPropertyData] = useState([]);
    const [edit, setEdit] = useState(false);
    const [deleteModel, setDelete] = useState(false);
    const [selectedId, setSelectedId] = useState();
    const [selectedValues, setSelectedValues] = useState([]);
    const [isImportProperty, setIsImportProperty] = useState(false);
    const location = useLocation();
    const region = location.state?.region.region;
    //console.log(region)
    let data = useSelector((state) => state?.propertyData?.data)
     data = region ? 
        data.filter((property) => property.region === region) : 
        data;
//console.log(data)
    const fetchCustomDataFields = async () => {
        setIsLoding(true);
        const result = await dispatch(fetchPropertyCustomFiled())
        if (result.payload.status === 200) {
            setPropertyData(result?.payload?.data);
        } else {
            toast.error("Failed to fetch data", "error");
        }
        const actionHeader = {
                Header: "Action",
                accessor: "action",
                isSortable: false,
                center: true,
                cell: ({ row, i }) => (
                  <Flex justifyContent="center" gap={2}>
                    {permission?.update && (
                      <Tooltip label="Edit" fontSize="sm" placement="top">
                        <Box
                          as="button"
                          onClick={() => {
                            setEdit(true);
                            setSelectedId(row?.values?._id);
                          }}
                        >
                          <EditIcon fontSize={20} />
                        </Box>
                      </Tooltip>
                    )}
                    {/* {callAccess?.create && (
                      <Tooltip label="Create Call" fontSize="sm" placement="top">
                        <Box
                          as="button"
                          onClick={() => {
                            setPhoneRec(row?.original);
                            setAddPhoneCall(true);
                            setCallSelectedId(row?.values?._id);
                          }}
                        >
                          <PhoneIcon fontSize={20} />
                        </Box>
                      </Tooltip>
                    )}
                    {emailAccess?.create && (
                      <Tooltip label="Send Email" fontSize="sm" placement="top">
                        <Box
                          as="button"
                          onClick={() => {
                            handleOpenEmail(row?.values?._id, row?.original);
                            setSelectedId(row?.values?._id);
                          }}
                        >
                          <EmailIcon fontSize={20} />
                        </Box>
                      </Tooltip>
                    )} */}
                    {permission?.view && (
                      <Tooltip label="View" fontSize="sm" placement="top">
                        <Box
                          as="button"
                          color="green.500"
                          onClick={() => {
                            navigate(`/propertyView/${row?.values?._id}`, {
                              state: { leadList: data },
                            });
                          }}
                        >
                          <ViewIcon fontSize={20} />
                        </Box>
                      </Tooltip>
                    )}
                    {permission?.delete && (
                      <Tooltip label="Delete" fontSize="sm" placement="top">
                        <Box
                          as="button"
                          color="red.500"
                          onClick={() => {
                            setDelete(true);
                            setSelectedValues([row?.values?._id]);
                          }}
                        >
                          <DeleteIcon fontSize={20} />
                        </Box>
                      </Tooltip>
                    )}
                  </Flex>
                ),
              };
        const tempTableColumns = [
            { Header: "#", accessor: "_id", isSortable: false, width: 10 },
            ...(result?.payload?.data?.[0]?.fields || []) // Ensure result.payload[0].fields is an array
                .filter(field => field?.isTableField === true) // Filter out fields where isTableField is true
                .map(field => ({ Header: field?.label, accessor: field?.name })),
            ...(permission?.update || permission?.view || permission?.delete ? [actionHeader] : [])
        ];


        setSelectedColumns(JSON.parse(JSON.stringify(tempTableColumns)));
        setColumns(JSON.parse(JSON.stringify(tempTableColumns)));
        setColumns(tempTableColumns);
        setTableColumns(JSON.parse(JSON.stringify(tempTableColumns)));
        setIsLoding(false);
    }

    const handleDeleteProperties = async (ids) => {
        try {
            setIsLoding(true)
            let response = await deleteManyApi('api/property/deleteMany', ids)
            if (response.status === 200) {
                setSelectedValues([])
                setDelete(false)
                setAction((pre) => !pre)
            }
        } catch (error) {
            //console.log(error)
        }
        finally {
            setIsLoding(false)
        }
    }

    useEffect(() => {
        dispatch(fetchPropertyData());
        fetchCustomDataFields();
    }, [action])

    useEffect(() => {
        setDataColumn(tableColumns?.filter(item => selectedColumns?.find(colum => colum?.Header === item.Header)));
    }, [tableColumns, selectedColumns])

    return (
        <div>
            <Grid templateColumns="repeat(6, 1fr)" mb={3} gap={4}>
                {!isLoding &&
                    <GridItem colSpan={6}>
                        <CommonCheckTable
                            title={title}
                            isLoding={isLoding}
                            columnData={columns ?? []}
                            dataColumn={dataColumn ?? []}
                            allData={data ?? []}
                            tableData={data}
                            tableCustomFields={propertyData?.[0]?.fields?.filter((field) => field?.isTableField === true) || []}
                            access={permission}
                            action={action}
                            setAction={setAction}
                            selectedColumns={selectedColumns}
                            setSelectedColumns={setSelectedColumns}
                            isOpen={isOpen}
                            onClose={onclose}
                            onOpen={onOpen}
                            selectedValues={selectedValues}
                            setSelectedValues={setSelectedValues}
                            setDelete={setDelete}
                            setIsImport={setIsImportProperty}
                        />
                    </GridItem>
                }
            </Grid>
            {isOpen && <Add propertyData={propertyData[0]} isOpen={isOpen} size={size} onClose={onClose} setAction={setAction} />}
            {edit && <Edit isOpen={edit} size={size} propertyData={propertyData[0]} selectedId={selectedId} setSelectedId={setSelectedId} onClose={setEdit} setAction={setAction} />}
            {deleteModel && <CommonDeleteModel isOpen={deleteModel} onClose={() => setDelete(false)} type='Properties' handleDeleteData={handleDeleteProperties} ids={selectedValues} />}
            {isImportProperty && <ImportModal text='Property file' isOpen={isImportProperty} onClose={setIsImportProperty} customFields={propertyData?.[0]?.fields || []} />}

        </div>
    )
}

export default Index